import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ValidationHandlerService, ModalBaseComponent } from 'lib/Vestra.shared';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdminToVestraUsersResultModel, MessageDeliveryStatus, MessageSentType, MessageSentTypeResultModel } from 'src/app/services/api-services';

type ResultColumn = 'disabledInTheAppCount' | 'invalidFCMTokenCount';

@Component({
    selector: 'app-notification-result',
    templateUrl: './notification-result.component.html',
    styleUrls: ['./notification-result.component.scss'],
})
export class NotificationResultComponent extends ModalBaseComponent implements OnInit {
    constructor(
        public bsModalRef: BsModalRef,
        protected override validationHandlerService: ValidationHandlerService,
        protected override modalService: BsModalService,
        protected override spinnerService: NgxSpinnerService
    ) {
        super(spinnerService, modalService, validationHandlerService);
    }

    //input properties
    public title: string;
    public item: AdminToVestraUsersResultModel;

    //class properties
    public isEmailResult: boolean = false;
    public messageDeliveryStatusClass: string = '';
    private readonly messageDeliveryStatusClasses: Record<MessageDeliveryStatus, string> = {
        [MessageDeliveryStatus.FullySuccessful]: 'message-delivery-status-fully-successful',
        [MessageDeliveryStatus.PartiallySuccessful]: 'message-delivery-status-partially-successful',
        [MessageDeliveryStatus.Failed]: 'message-delivery-status-failed',
        [MessageDeliveryStatus.NotSet]: 'message-delivery-status-not-set',
        [MessageDeliveryStatus.NotSent]: 'message-delivery-status-not-sent',
    };

    private readonly notApplicableColumns: Partial<Record<MessageSentType, ResultColumn[]>> = {
        [MessageSentType.InApp]: ['invalidFCMTokenCount'],
        [MessageSentType.Email]: ['invalidFCMTokenCount'],
    };

    private getFormGroup(): FormGroup {
        return new FormGroup({
            allUserCount: new FormControl({ value: 0, disabled: true }),
            sentCount: new FormControl({ value: '', disabled: true }),
            fullyDelivered: new FormControl({ value: '', disabled: true }),
            errors: new FormControl({ value: '', disabled: true }),
        });
    }
    public form: FormGroup = this.getFormGroup();

    public init() {
        this.form = this.getFormGroup();

        if (this.item) {
            this.isEmailResult = this.item.messageSentTypeResults?.some(x => x.messageSentType === MessageSentType.Email) ?? false;
            this.messageDeliveryStatusClass = this.messageDeliveryStatusClasses[this.item.messageDeliveryStatus];
            this.form.patchValue({
                allUserCount: this.item.allUserCount,
                sentCount: `${this.item.successCount} / ${this.item.all}`,
                fullyDelivered: `${this.item.fullyDelivered} / ${this.item.allUserCount}`,
                errors: (this.item.errors ?? []).join('\n'),
            });
        }
    }

    public ngOnInit() {
        this.init();
    }

    public getCellValue(result: MessageSentTypeResultModel, column: ResultColumn): number | string {
        return this.isApplicable(result, column) ? result[column] : 'X';
    }
    public getTotalValue(column: ResultColumn): number | string {
        const isAnyApplicable = this.item?.messageSentTypeResults?.some(result => this.isApplicable(result, column)) ?? false;
        return isAnyApplicable ? this.item[column] : 'X';
    }

    private isApplicable(result: MessageSentTypeResultModel, column: ResultColumn): boolean {
        return !this.notApplicableColumns[result.messageSentType]?.includes(column);
    }
}
